
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template_dialog_notification from '@/../templates/dialog-notification.hbs';

var alertCh = Radio.channel('alerts');
var apiCh = Radio.channel('api');

function show_alert(type, message) {
    return alertCh.request('showAlert', {
        message: message,
        messageType: type,
        timeout: 2000
    });
}

var NotificationDialogView = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template_dialog_notification),
    ui: {
        delete_btn: '.delete-btn',
    },
    events: {
        'click @ui.delete_btn': 'onclick_delete_notification',
        'click @ui.close': 'show_close',
    },
    initialize: function (options) {
        this.destroyOnClose();
    },
    onRender: function() {
        const notifications = apiCh.request('notification');
        notifications.fetch();
    },
    handle_submit: function(e) {
        e.preventDefault();
    },
    templateContext: function () {
        let fa;
        switch (this.model.get('priority')) {
            case 1:
                fa = 'times-circle';
                break;
            case 2:
                fa = 'exclamation-triangle';
                break;
            case 3:
                fa = 'info-circle';
                break;
            case 4:
                fa = 'info-circle';
                break;
            case 5:
                fa = 'info-circle';
                break;
            default:
                fa = 'info-circle';
        }
        return {
            fa,
        };
    },
    onclick_delete_notification: function() {
        this.model.collection.delete([this.model]);
        show_alert('success', 'Notification deleted');
        this.closeDialog();
    },
});
export default NotificationDialogView;

